/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DeviceTrendPoints,
  DeviceTrendPoints$inboundSchema,
} from "./devicetrendpoints.js";

export type ListDeviceTrendPointsResponse = {
  /**
   * The device trend points.
   */
  values: Array<DeviceTrendPoints>;
};

/** @internal */
export const ListDeviceTrendPointsResponse$inboundSchema: z.ZodType<
  ListDeviceTrendPointsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  values: z.array(DeviceTrendPoints$inboundSchema),
});

export function listDeviceTrendPointsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListDeviceTrendPointsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDeviceTrendPointsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDeviceTrendPointsResponse' from JSON`,
  );
}
